// src/components/ChatWindow.jsx
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import useChatHub from "../hooks/useChatHub";
import "./ChatWindow.css";

const ChatWindow = ({ session, chatMessages, onSendMessage }) => {
  const [showChat, setShowChat] = useState(false);
  const [chatInput, setChatInput] = useState("");

  // Use the custom hook for the SignalR connection.
  const { sendMessage } = useChatHub(session, (msg) => {
    // Update the UI when a new message is received.
    onSendMessage(msg);
  });

  const toggleChat = () => {
    setShowChat((prev) => !prev);
  };

  const handleSendMessage = () => {
    if (!chatInput.trim()) return;
    const newMsg = {
      sender: "reception", // adjust as needed
      text: chatInput.trim(),
      timestamp: new Date().toISOString(),
    };

    // Send the message via SignalR.
    if (session && session.roomNumber) {
      sendMessage(session.roomNumber, newMsg.sender, newMsg.text);
    }
    // Also update the UI locally.
    onSendMessage(newMsg);
    setChatInput("");
  };

  return (
    <div className="chat-container">
      {!showChat && (
        <button className="chat-toggle-btn" onClick={toggleChat}>
          <FontAwesomeIcon icon={faComments} style={{ marginRight: "0.3rem" }} />
          Chat with Reception
        </button>
      )}
      {showChat && (
        <div className="chat-window">
          <div className="chat-header">
            <span>
              Chat for Room {session?.roomNumber} – {session?.guestName}
            </span>
            <button className="close-chat-btn" onClick={toggleChat}>
              &times;
            </button>
          </div>
          <div className="chat-messages">
            {chatMessages.map((msg, idx) => (
              <div
                key={idx}
                className={`chat-message ${
                  msg.sender === "guest" ? "guest-msg" : "reception-msg"
                }`}
              >
                <p>{msg.text}</p>
                <span className="msg-time">
                  {new Date(msg.timestamp).toLocaleTimeString()}
                </span>
              </div>
            ))}
          </div>
          <div className="chat-input-bar">
            <input
              type="text"
              placeholder="Type your message..."
              value={chatInput}
              onChange={(e) => setChatInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSendMessage()}
            />
            <Button variant="primary" onClick={handleSendMessage}>
              Send
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatWindow;
